module.exports = "<div class=\"toggle-checkbox\" (click)=\"toggle()\">\n    <button type=\"button\" class=\"btn btn-sm\" [ngClass]=\"getButtonClass()\">{{ (selected ? 'Yes' : 'No') | translate }}</button>\n    <label>{{ text }}</label>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/components/toggle-checkbox/toggle-checkbox.component.html
// module id = ../../../../../resources/assets/src/app/shared/components/toggle-checkbox/toggle-checkbox.component.html
// module chunks = main